export default "__VITE_ASSET__Txpkdwib__"